import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';
import {KEY_PREFIX} from '../actions/populate_manual_weather';

export const manualWeatherAugmenter = store => next => action => {

  // Intercepts message before reducer to augment with point data.
  switch (action.type) {
    case ActionTypes.SET_MANUAL_WEATHER_DATA:
    case ActionTypes.SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
      const { point, incidents } = store.getState();
      action.lat = point.lat;
      action.lng = point.lng;
      action.mgrs = point.mgrs;
      action.burn = incidents.active ? incidents.active.eventId : undefined;
      break;
    default:
      break;
  }

  switch (action.type) {
    case ActionTypes.SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
      action.weather_row_keys = _.keys(store.getState().point_data_weather.table_data);
      break;
    default:
      break;
  }

  return next(action);
};

export const manualWeatherPersistence = store => next => action => {

  // Capture the active manual weather pre action in case it gets removed.
  const preActionActiveManualWeather = store.getState().manual_weather.active;

  // Let the action complete.
  const result = next(action);

  // We handle these cases post action
  switch (action.type) {
    case ActionTypes.SET_MANUAL_WEATHER_DATA:
    case ActionTypes.SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
    case ActionTypes.RESET_ALL_MANUAL_WEATHER_DATA:
    case ActionTypes.RESET_MANUAL_WEATHER_DATA:
    case ActionTypes.RESET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
      const { manual_weather } = store.getState();
      if (manual_weather.active) {
        const key = manual_weather.active.properties.key.replaceAll(' ', '_');
        if (_.keys(manual_weather.active.properties.data).length > 0) {
          localStorage.setItem(`${KEY_PREFIX}_${key}`, JSON.stringify(manual_weather.active));
        } else {
          localStorage.removeItem(`${KEY_PREFIX}_${key}`);
        }
      } else if (preActionActiveManualWeather) {
        // The active weather was cleared.
        const key = preActionActiveManualWeather.properties.key.replaceAll(' ', '_');
        localStorage.removeItem(`${KEY_PREFIX}_${key}`);
      }
      break;
    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/manualWeatherMiddleware.js